import AllocationViewCard from "./components/AllocationViewCard/AllocationViewCard";
import MetricViewCard from "./components/MetricViewCard/MetricViewCard";

export const DRAWER_TYPES = {
  ALLOCATION: "ALLOCATION",
  METRIC: "METRIC",
};

export const DRAWER_COMPONENTS = {
  [DRAWER_TYPES.ALLOCATION]: AllocationViewCard,
  [DRAWER_TYPES.METRIC]: MetricViewCard,
};
